const spinner = function() {
    this.initializeLoadingSpinner = function($spinnerContainer, $spinnerElement, loadingEventId) {
        this.$spinnerContainer = $spinnerContainer;
        this.$spinnerElement = $spinnerElement;
        this.loadingEventId = loadingEventId;

        if (!this.$spinnerElement) {
            this.$spinnerElement = $('<span class="spinner" data-hidden />');
            this.$spinnerContainer.parent().append(this.$spinnerElement);
        }

        this.on(document, 'uiSpinnerShow', this.showSpinner);
        this.on(document, 'uiSpinnerHide', this.hideSpinner);
    };

    this.positionSpinner = function() {
        var spinnerHeight = this.$spinnerElement.outerHeight();
        var spinnerWidth = this.$spinnerElement.outerWidth();
        var containerOffset = this.$spinnerContainer.offset();
        var boxTop = Math.max($(window).scrollTop(), containerOffset.top);
        var boxLeft = Math.max($(window).scrollLeft(), containerOffset.left);
        var boxBottom = Math.min(
            containerOffset.top + this.$spinnerContainer.outerHeight(),
            $(window).scrollTop() + $(window).height()
        );
        var boxRight = Math.min(
            containerOffset.left + this.$spinnerContainer.outerWidth(),
            $(window).scrollLeft() + $(window).width()
        );

        if (boxBottom - boxTop > spinnerHeight && boxRight - boxLeft > spinnerWidth) {
            this.$spinnerElement.offset({
                top: boxTop + (boxBottom - boxTop - spinnerHeight) / 2,
                left: boxLeft + (boxRight - boxLeft - spinnerWidth) / 2,
            });
            return true;
        }

        return false;
    };

    this.isInterestedLoadingEvent = function(loadingEventId) {
        return !loadingEventId || !this.loadingEventId || loadingEventId === this.loadingEventId;
    };

    this.showSpinner = function(e, data) {
        var loadingEventId = data && data.id ? data.id : null;

        if (this.isInterestedLoadingEvent(loadingEventId)) {
            this.$spinnerElement.removeAttr('data-hidden');
            this.$spinnerContainer.addClass('spinner-target');

            if (this.positionSpinner()) {
                this.$spinnerElement.css({ visibility: 'visible' });
            } else {
                this.$spinnerElement.attr('data-hidden', true);
            }
        }
    };

    this.hideSpinner = function(e, data) {
        var loadingEventId = data && data.id ? data.id : null;

        if (this.isInterestedLoadingEvent(loadingEventId)) {
            this.$spinnerContainer.removeClass('spinner-target');
            this.$spinnerElement.css({ visibility: 'hidden' });
            this.$spinnerElement.attr('data-hidden', true);
        }
    };
};

export default spinner;



// WEBPACK FOOTER //
// ./src/web/js/app/mixins/with-loading-spinner.js